<template>
    <v-container fluid>
        <v-layout justify-center>
            <v-flex md10>
                <FormPerson :model="person" :on-success="savePerson" :on-cancel="cancel" :edit="isEdit" />
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import FormPerson from '@/components/forms/PersonForm'
import router from '@/router'
export default {
  data: () => ({
    isEdit: false,
    person: {
      id: 0,
      ife: '',
      datos: {
        direccion: {},
        contacto: {},
        distrito: {}
      }
    }
  }),
  components: {
    FormPerson
  },
  mounted () {
    if (this.$route.params.id) {
      this.person.id = this.$route.params.id
      this.getUrl('person.show')
    }
  },
  methods: {
    ...mapActions(['postUrlServicesAction', 'getUrlServices', 'postUrlServiceActionSecound']),
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postUrlServicesAction({ url: router, data: this.person })
      } else {
        this.getUrlServices()
      }
    },
    postUrl (objet) {
      const router = this.get_urls[objet]
      // router.data = this.person
      this.postUrlServiceActionSecound({ url: router, data: this.person })
    },
    savePerson (model) {
      this.person = model
      this.postUrl('person.update')
    },
    cancel () {
      router.push({ name: 'ViewPersonas' })
    },
    ...mapMutations([])
  },
  computed: {
    ...mapGetters(['get_urls', 'get_object', 'get_objectSecound'])
  },
  watch: {
    get_urls () {
      this.getUrl('person.show')
    },
    get_object (val) {
      this.person = val
      this.isEdit = true
    },
    get_objectSecound (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitos!',
        text: 'Se actualizo correctamente los datos'
      })
      this.cancel()
    }
  },
  beforeDestroy () {
  }
}
</script>

<style>

</style>
